const React = require('react');
const ReactRedux = require('react-redux');
const PropTypes = require('prop-types');
const createReactClass = require('create-react-class');


const Radio = require('../components/Radio.jsx');
const Checkbox = require('../components/Checkbox.jsx');
const Dropdown = require('../components/Dropdown.jsx');
const BuildStatus = require('../components/BuildStatus.jsx');
const ButtonGitUpdate = require('./buttons/GitUpdate.jsx');
const SaveTargetRelease = require('./buttons/SaveTargetRelease.jsx');

const actions = require('../_actions.js');
const constants = require('../constants/deployment.js');

const TargetRelease = createReactClass({
	getInitialState: function() {
		return {
			options_open: false,
			advanced_open: false,
		};
	},

	toggleAdvancedOpen: function() {
		const advanced = document.getElementsByClassName('advanced_deployment_option');
		for (var i = 0; i < advanced.length; i++) {
			advanced[i].classList.toggle('hide');
		}
		this.setState(prevState => ({
			advanced_open: !prevState.advanced_open,
			options_open: !prevState.options_open,
		}));
	},

	render: function() {
		const props = this.props;
		const typeFields = {};

		Object.keys(props.types).forEach(function(key) {
			let promoteBuildDeployment = null;
			if (props.types[key].promote_build) {
				promoteBuildDeployment = props.types[key].promote_build.attributes;
			}

			switch (key) {
				case constants.REF_TYPE_FROM_UAT:
				case constants.REF_TYPE_REDEPLOY_CURRENT: // Promote build options (from UAT, and re-deploy current)
					typeFields[key] = (
						<BuildStatus status_box status_ago deployment={promoteBuildDeployment} commitAsLink />
					);
					break;
				case constants.REF_TYPE_BRANCH: // Dropdowns for branch, and tags
				case constants.REF_TYPE_TAG:
				case constants.REF_TYPE_PACKAGE_ARCHIVE:
					typeFields[key] = (
						<Dropdown
							onSelect={props.onRefSelect}
							options={props.ref_list}
							value={props.selected_id}
							disabled={props.disabled}
							name={"ref_selector_" + key}
						/>
					);
					break;
				case constants.REF_TYPE_PACKAGE:
				case constants.REF_TYPE_SHA: // Input SHA option
					typeFields[key] = (
						<input
							className="field text"
							type="text"
							name="selected_ref"
							onChange={props.onShaChange}
							value={props.selected_id}
							disabled={props.disabled}
						/>
					);
					break;
				default:
					break;
			}
		});

		const list = Object.keys(props.types).map(function(key, index) {
			if (props.types[key].advanced) {
				return '';
			}

			let extraFields = null;
			if (props.selected_type === props.types[key].id) {
				extraFields = typeFields[props.types[key].id];
			}

			let small = '';
			let classes = '';
			if (props.types[key].small) {
				small = <small>{props.types[key].small}</small>;
				classes = 'radio-with-small';
			}

			return (
				<li key={props.types[key].id} className={classes} >
					<Radio
						description={props.types[key].description}
						name="type"
						checked={props.selected_type === props.types[key].id}
						id={index}
						onClick={() => props.onRadioClick(props.types[key].id, props.types[key])}
						disabled={props.disabled}
					/>
					{small}
					{extraFields}
				</li>
			);
		});

		const advanced_list = Object.keys(props.types).map(function(key, index) {
			if (!props.types[key].advanced) {
				return '';
			}

			let extraFields = null;
			if (props.selected_type === props.types[key].id) {
				extraFields = typeFields[props.types[key].id];
			}

			let small = '';
			let classes = '';
			if (props.types[key].small) {
				small = <small>{props.types[key].small}</small>;
				classes = 'radio-with-small';
			}
			classes += ' advanced_deployment_option hide';

			return (
				<li key={props.types[key].id} className={classes} >
					<Radio
						description={props.types[key].description}
						name="type"
						checked={props.selected_type === props.types[key].id}
						id={index}
						onClick={() => props.onRadioClick(props.types[key].id, props.types[key])}
						disabled={props.disabled}
					/>
					{small}
					{extraFields}
				</li>
			);
		});

		let advanced_text = "Hide advanced options";
		let caret = 'up';
		if (!this.state.advanced_open) {
			advanced_text = "Show advanced options";
			caret = 'down';
		}
		const advanced_types_toggle = (
			<div className="advanced_toggle">
				<a href={"javascript:void(0);"} onClick={this.toggleAdvancedOpen}>
					{advanced_text} <i className={"fa fa-caret-" + caret}></i>
				</a>
			</div>
		);

		const fetchClasses = this.props.git_loading ? 'loading' : '';
		return (
			<div>
				{this.props.last_fetched_date && <div className={'fetch ' + fetchClasses} >
					<ButtonGitUpdate />
					<div className="fetchContent">
						<i className="fa fa-code" aria-hidden="true"></i> Last synced {this.props.last_fetched_date}
						&nbsp;<span className="small">{this.props.last_fetched_ago}</span>
					</div>
					<div className="fetchContent"><i>Ensure you have the most recent code before setting up your deployment</i></div>
				</div>}

				<div className="section target-release">
					<header><h4>Target release</h4></header>
					<div>
						Select the release you would like to deploy to {props.environment_name}
					</div>
					<form className="form" onSubmit={props.onSubmit}>
						<ul className="radio-list">
							{list}
							{advanced_types_toggle}
							{advanced_list}
						</ul>
						<ul className="checkbox-list advanced_deployment_option hide">
							{props.options.map(function(option, index) {
								const idx = index;
								return (
									<li key={idx}>
										<Checkbox
											description={option.title}
											name="option"
											checked={props.selected_options[option.name] === true}
											id={index}
											onClick={() => props.onCheckboxClick(option.name)}
											disabled={props.disabled}
										/>
									</li>
								);
							})}
						</ul>
					</form>
				</div>
				<SaveTargetRelease />
			</div>
		);
	}
});

TargetRelease.propTypes = {
	types: PropTypes.object.isRequired,
	selected_type: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	options: PropTypes.array,
	selected_options: PropTypes.object,
	ref_list: PropTypes.array,
	selected_release: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	disabled: PropTypes.bool.isRequired
};

function isDisabled(state) {
	if (state.plan.is_loading) {
		return true;
	}
	const current = state.deployment.list[state.deployment.current_id] || {};
	if (constants.isSubmitted(current.state)) {
		return true;
	}
	if (constants.isApproved(current.state)) {
		return true;
	}
	if (constants.isRejected(current.state)) {
		return true;
	}
	if (constants.isQueued(current.state)) {
		return true;
	}
	return false;
}

const mapStateToProps = function(state) {
	let selected_id = state.git.selected_release;
	let refs = [];
	// the user have chosen to pick a release from a list (dropdown).
	if (state.git.list[state.git.selected_type] && state.git.list[state.git.selected_type].list) {
		refs = state.git.list[state.git.selected_type].list;
		// a list is keyed by sha1 and the value so that we can have multiple unique values
		// see reducers/git.js SUCCEED_REVISIONS_GET and SET_REVISION
		if (state.git.selected_name && state.git.selected_release !== state.git.selected_name) {
			selected_id = state.git.selected_release + "_" + state.git.selected_name;
		}
	}

	return {
		environment_name: state.environment.name,
		types: state.git.list,
		selected_type: state.git.selected_type,
		options: state.git.options,
		selected_options: state.git.selected_options,
		ref_list: refs,
		selected_id: selected_id,
		last_fetched_date: state.git.last_fetched_date,
		last_fetched_ago: state.git.last_fetched_ago,
		disabled: isDisabled(state),
		git_loading: (state.git.is_fetching || state.git.is_updating)
	};
};

const mapDispatchToProps = function(dispatch) {
	return {
		onRadioClick: function(id, type) {
			dispatch(actions.setGitRefType(id));
			if (type.promote_build) {
				dispatch(actions.setGitRef(type.promote_build.attributes.sha + '_' + type.promote_build.attributes.package_id));
			}
		},
		onCheckboxClick: function(name) {
			dispatch(actions.toggleOption(name));
		},
		onRefSelect: function(ref) {
			dispatch(actions.setGitRef(ref));
		},
		onShaChange: function(e) {
			dispatch(actions.setGitRef(e.target.value));
		},
		onSubmit: function(e) {
			e.preventDefault();
			dispatch(actions.getDeploySummary());
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(TargetRelease);
